<template>
    <div>
        <compFormQuery v-if="alltype=='query'" class="margin-top-15 margin-right-15" :formdata="getClear" :value="formData" :labelWidth="120"></compFormQuery>
		<compFormEdit v-else class="margin-top-15 margin-right-15" :formdata="getClear" v-model="formData" :labelWidth="120" ref="clearform"></compFormEdit>
        <vButton v-if="alltype!='query'" class="margin-left-40" theme="primary" @click="addItem">{{$t('global.common.add_detail',{defaultValue:'添加详细'})}}</vButton>
        <vTable
            class="margin-left-10 margin-right-10 margin-top-15"
            :columns="columns" 
            :data="formList"
            size="small" 
            ref="table"  
            border 
        ></vTable>
        <!-- <vModal :title="titleclear" v-model="visible" :showFooter="false">
            <compAddclear ref="refaddclear" :alltype="alltype" :cleardata="compclear"  @on-update="addItem" @on-close="visible = false"></compAddclear>
        </vModal> -->
    </div>
</template>

<script>
import { HttpGetContry } from '@/service/boss/dictionary'
import {
	HttpGetCurrency
} from '@/service/products/allproducts'
// 
// import compAddclear from './addclear'
import { mapState,mapGetters } from "vuex";
export default {
    props:['alltype','clearformdata','compfobPrice'],
    components: {
		compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        // compAddclear
    },
    data(){
        return {
            formData:{},
            formList:[],
            visible:false,
            titleclear:'',
            compclear:{},
            currencyCodeList:[
                // {value:'USD',label:'USD'}
            ]
        }
    },
    created(){
        this.getCurrenyList()
    },
    computed:{
        ...mapState('boss', ['countries']),
        getClear(){
            return [
                {
					label: this.$t('erp.product.customname_china',{defaultValue:'报关品名(中文)'}),
					key: "htsName",
					tag: "vInput",
                },
                {
					label: this.$t('erp.product.custom_name',{defaultValue:'报关品名(英文)'}),
					key: "htsNameEn",
					tag: "vInput",
                },
                {
					label: this.$t('erp.product.chinese_code',{defaultValue:'中国报关代码'}),
					key: "htsCode",
					tag: "vInput",
					required: false,
				},
            ]
        },
        columns(){
            let _this = this;
            return [
                // 国家代码
                {
                    // title: "国家代码",
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('Icon',{
                                props:{
                                    type:"ios-medical",
                                    color:"#ed3f14"
                                },
                            }),
                            h('strong',this.$tc('global.common.country',2,{defaultValue:'国家编码'}))
                        ])
                    },
                    render(h, { row,index }) {
                        if(row.$Edit){
                            return h('vSelect',{
                                attrs:{
                                    transfer:true,
                                    },
                                    props:{  
                                        value: _this.formList[index].countryCode,
                                        filterable:true,
                                        clearable:true,
                                    },  
                                    on: {  
                                        'on-change':(value) => {  
                                            _this.formList[index].countryCode = value
                                        }  
                                    },  
                                },
                                _this.countries.map((json)=>{
                                    // console.log(json)  
                                    return h('vOption', {  
                                        props: {
                                            value: json.code,
							                label: json.code + " (" + (global.LANG == 'zh-CN' ? json.name : json.nameEn) + ")"
                                        }  
                                    });  
                                })
                            )
                        }else{
                            return <div>{row.countryCode}</div>
                        }
                    }
                },
                // HS Code
                {
                    key: 'customCode',
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('Icon',{
                                props:{
                                    type:"ios-medical",
                                    color:"#ed3f14"
                                },
                            }),
                            h('strong',' HS Code')
                        ])
                    },
                    render(h, { row,index }) {
                        if(row.$Edit){
                            return h('Input',{
                                props: {
                                    size:'small',
                                    value:row.customCode
                                },
                                on: {
                                    'input':(event) => {
                                        row.customCode = event
                                        _this.formList[index] = row
                                    }
                                },
                            })
                        }else{
                            return <div>
                            {row.customCode}
                            </div>
                        }
                    }
                },
                // 币种
                // {
                //     key: 'currencyCode',
                //     renderHeader:(h,params)=>{
                //         return h('div',[
                //             h('Icon',{
                //                 props:{
                //                     type:"ios-medical",
                //                     color:"#ed3f14"
                //                 },
                //             }),
                //             h('strong',this.$t('global.common.currency',{defaultValue:'币种'}))
                //         ])
                //     },
                //     render(h, { row,index }) {
                //         if(row.$Edit){
                //             return h('vSelect',{
                //                 attrs:{
                //                     transfer:true,
                //                 },
                //                 props:{  
                //                     value: _this.formList[index].currencyCode,
                //                 },  
                //                 on: {  
                //                     'on-change':(value) => {  
                //                         // console.log(value)
                //                         _this.formList[index].currencyCode = value
                //                         let itemcur = _this.currencyCodeList.filter(item=> value == item.currency)
                //                         // console.log(itemcur)
                //                         if(_this.compfobPrice){
                //                             _this.formList[index].fobPrice = _this.compfobPrice*itemcur[0].rate
                //                         }
                //                     }  
                //                 },  
                //             },
                //                 _this.currencyCodeList.map((json)=>{  
                //                     return h('vOption', {  
                //                         props: {
                //                             value: json.currency,
				// 			                label: json.currency+'('+json.currencyCn+')'
                //                         }  
                //                     });  
                //                 })
                //             )
                //         }else{
                //             return <div>{row.currencyCode}</div>
                //         }
                //     }
                // },
                // // FOB
                // {
                //     key: 'fobPrice',
                //     renderHeader:(h,params)=>{
                //         return h('div',[
                //             h('Icon',{
                //                 props:{
                //                     type:"ios-medical",
                //                     color:"#ed3f14"
                //                 },
                //             }),
                //             h('strong',' FOB')
                //         ])
                //     },
                //     render(h, { row,index }) {
                //         if(row.$Edit){
                //             return h('vInput',{
                //                 props: {
                //                     size:'small',
                //                     value:row.fobPrice
                //                 },
                //                 on: {
                //                     'input':(event) => {
                //                         row.fobPrice = event
                //                         _this.formList[index] = row
                                        
                //                         let num;
                //                         if(event){
                //                             num = event*(1-(_this.formList[index].customDiscountRate || 0)/100)                                            
                //                         }
                //                         _this.formList[index].customDiscountPrice = num.toFixed(4)
                //                     },
                //                     'on-blur':(event)=>{
                //                         if(event>10000000000){
                //                             this.$VMessage.error(this.$t('erp.product.fob_length_attention', { defaultValue: 'FOB长度不能超过 10000000000' }))
                //                         }
                //                     }
                //                 },
                //             })
                //         }else{
                //             return <div>
                //             {row.fobPrice}
                //             </div>
                //         }
                //     }
                // },
                // 关税(%)
                {
                    key: 'importTaxRate',
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('Tooltip',{
                                props:{
                                    placement:'top',
                                    transfer:true,
                                    content:this.$t('erp.product.tip_1', { defaultValue: '系统已带百分号，比如7%，请在文本框填写7即可' })
                                }
                            },[
                                h('Icon',{
                                    props:{
                                        type:"ios-medical",
                                        color:"#ed3f14"
                                    },
                                }),
                                h('strong',this.$t('erp.product.tariff',{defaultValue:'关税(%)'})),
                                h('Icon',{
                                    props:{
                                        type:"md-help-circle",
                                        color:"#ed3f14"
                                    },
                                }),
                            ]
                            )
                        ])
                    },
                    render(h, { row,index }) {
                        if(row.$Edit){
                            return h('Input',{
                                props: {
                                    size:'small',
                                    value:row.importTaxRate
                                },
                                on: {
                                    'input':(event) => {
                                        row.importTaxRate = event
                                        _this.formList[index] = row
                                    }
                                },
                            })
                        }else{
                            return <div>
                            {row.importTaxRate}
                            </div>
                        }
                    }
                },
                {
                    key: 'customDiscountRate',
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('Tooltip',{
                                props:{
                                    placement:'top',
                                    transfer:true,
                                    content:this.$t('erp.product.tip_1', { defaultValue: '系统已带百分号，比如7%，请在文本框填写7即可' })
                                }
                            },[
                                h('Icon',{
                                    props:{
                                        type:"ios-medical",
                                        color:"#ed3f14"
                                    },
                                }),
                                h('strong',this.$t('erp.product.clear_discount',{defaultValue:'清关折扣率(%)'})),
                                h('Icon',{
                                    props:{
                                        type:"md-help-circle",
                                        color:"#ed3f14"
                                    },
                                }),
                            ]
                            )
                        ])
                    },
                    render(h, { row,index }) {
                        if(row.$Edit){
                            return h('Input',{
                                props: {
                                    size:'small',
                                    value:row.customDiscountRate
                                },
                                on: {
                                    'input':(event) => {
                                        row.customDiscountRate = event
                                        _this.formList[index] = row
                                        
                                        let num;
                                        if(_this.formList[index].fobPrice){
                                            num = _this.formList[index].fobPrice*(1-event/100)                                            
                                        }
                                        // console.log(_this.formList[index].fobPrice,num)
                                        _this.formList[index].customDiscountPrice = num.toFixed(4)
                                    }
                                },
                            })
                        }else{
                            return <div>
                            {row.customDiscountRate}
                            </div>
                        }
                    }
                },
                // {
                //     renderHeader:(h,params)=>{
                //         return h('div',[
                //             h('Tooltip',{
                //                 props:{
                //                     placement:'top',
                //                     transfer:true,
                //                     content:this.$t('erp.product.default_cleardiscount',{defaultValue:'默认自动计算，FOB-FOB*清关折扣率'})
                //                 }
                //             },[
                //                 h('strong',this.$t('erp.product.clear_price',{defaultValue:'清关价 '})),
                //                 h('Icon',{
                //                     props:{
                //                         type:"md-help-circle",
                //                         color:"#ed3f14"
                //                     },
                //                 }),
                //             ]
                //             )
                //         ])
                //     },
                //     render(h, { row,index }) {
                //         if(row.$Edit){
                //             return h('Input',{
                //                 props: {
                //                     size:'small',
                //                     value:row.customDiscountPrice
                //                 },
                //                 on: {
                //                     'input':(event) => {

                //                         row.customDiscountPrice = event
                //                         _this.formList[index] = row
                //                     }
                //                 },
                //             })
                //         }else{
                //             return <div>
                //             {row.customDiscountPrice}
                //             </div>
                //         }
                //     }
                // },
                {
                    title: this.$t('erp.product.clear_remark',{defaultValue:'清关说明'}),
                    render(h, { row,index }) {
                        if(row.$Edit){
                            return h('Input',{
                                props: {
                                    size:'small',
                                    value:row.customRemark
                                },
                                on: {
                                    'input':(event) => {
                                        row.customRemark = event
                                        _this.formList[index] = row
                                    }
                                },
                            })
                        }else{
                            return <div>
                            {row.customRemark}
                            </div>
                        }
                    }
                },
                {
                    title: this.$t('erp.product.estimated_freight',{defaultValue:'预估运费(USD)'}),
                    render(h, { row,index }) {
                        if(row.$Edit){
                            return h('Input',{
                                props: {
                                    size:'small',
                                    value:row.antcipatedFreight
                                },
                                on: {
                                    'input':(event) => {
                                        row.antcipatedFreight = event
                                        _this.formList[index] = row
                                    }
                                },
                            })
                        }else{
                            return <div>
                            {row.antcipatedFreight}
                            </div>
                        }
                    }
                },
                {
                    title: this.$t('global.common.operation',{defaultValue:'操作'}),
                    width:this.alltype!='query'?140:0,
                    render(h, { row, index }) {
                        return h('div',[
                            h('Button', {
                                props:{
                                    type:"primary",
                                    size:'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        _this.changeEdit(row,'edit')
                                    }
                                }
                            },this.$t('global.common.operation_edit',{defaultValue:'编辑'})),
                            h('Button', {
                                props:{
                                    type:"error",
                                    size:'small'
                                },
                                on: {
                                    click: () => {
                                        _this.comremove(index)
                                    }
                                }
                            },this.$t('global.common.delete',{defaultValue:'删除'}))
                        ])
                    }
                },
            ]
        }
    },
    methods:{
        getCurrenyList(){
            HttpGetCurrency().then(res=>{
                console.log(res)
                this.currencyCodeList = res.data
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        handledata(){
            // console.log(this.clearformdata)
            let { htsName,htsNameEn,htsCode } = this.clearformdata;
            this.formData = {htsName,htsNameEn,htsCode}

            this.formList = this.clearformdata.customs || []

            if(this.alltype == 'query') return

            // console.log(this.countries)
            // console.log(this.alltype)
        },
        addDetail(){
            // this.visible = true;
            // this.titleclear = '添加清关信息'
        },
        changeEdit(row,edittype){
            // console.log(row)
            // this.compclear = row
            // this.visible = true
            this.$set(row, '$Edit', true)
        },
        comremove(index){
            this.formList.splice(index, 1);
        },
        addclearbox(){

        },
        addItem(data){
            // console.log(this.countries)
            let obj = {
                countryCode:data.countryCode,
                customCode:data.customCode,
                currencyCode:data.currencyCode,
                fobPrice:data.fobPrice,
                importTaxRate:data.importTaxRate,
                customDiscountRate:data.customDiscountRate,
                customDiscountPrice:data.customDiscountPrice,
                customRemark:data.customRemark,
                antcipatedFreight:data.antcipatedFreight,
                $Edit:true,
            }
            this.formList.push(obj);
            this.visible = false
        },
        async validate(){
            const bool = await this.$refs['clearform'].validate();
            if (!bool) {
                this.$VMessage.warning(this.$t('global.common.fill_required',{defaultValue:'请填写必填项'}));
            }
            return bool;
		},
    },
    watch:{
        clearformdata(){

            // if(this.alltype != 'query'){
                this.handledata()
            // }
        }
    }
}
</script>